module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-hh.fed5e4fe.png";